/** Accepted terminal SSE evidence, scoped to the server submission id. */
const acceptedTerminals = new Map<string, "done" | "error">();
const MAX_REMEMBERED_TERMINALS = 512;

export function rememberAcceptedChatTerminal(
  submissionId: string,
  kind: "done" | "error",
): void {
  acceptedTerminals.delete(submissionId);
  acceptedTerminals.set(submissionId, kind);
  if (acceptedTerminals.size > MAX_REMEMBERED_TERMINALS) {
    const oldest = acceptedTerminals.keys().next().value;
    if (oldest !== undefined) acceptedTerminals.delete(oldest);
  }
}

export function hasAcceptedChatTerminal(submissionId?: string): boolean {
  return submissionId !== undefined && acceptedTerminals.has(submissionId);
}

export function clearAcceptedChatTerminalsForTests(): void {
  acceptedTerminals.clear();
}
